import {PersistentTrigger, TimeWindowCondition, type TriggerCondition, type TriggerFactory} from "./triggers";
import {Page} from "../page";
import {GLOBAL} from "../globals";
import {autoRegister, resolve} from "../../container";

import {done, fresh} from "../lifetime";
import {prepareEvents} from "../utils/events";

export class ScrollTrigger extends PersistentTrigger {
    private percentageToScroll: number;

    public constructor(
        private page: Page,
        protected element: Element,
        triggerConditions: TriggerCondition[],
        callback: () => void
    ) {
        super(triggerConditions, callback);

        this.percentageToScroll = this.element.getAttribute("data-trigger-percent-scrolled")?.toInt() ?? 50;
        prepareEvents(GLOBAL.window())
            .boundTo(fresh(this.element, "scrolltrigger"))
            .on("scroll", () => this.onPercentageScrolled());
    }

    private onPercentageScrolled(): void {
        if (!this.triggered && this.page.percentageScrolled() >= this.percentageToScroll) {
            this.trigger();
            this.triggered = true;
        }
    }

    public stop(): void {
        super.stop();
        done(this.element, "scrolltrigger");
    }
}

@autoRegister()
export class ScrollTriggerFactory implements TriggerFactory {
    public constructor(private page: Page = resolve(Page)) {
    }

    public createTrigger(element: Element, callback: () => void): ScrollTrigger {
        return new ScrollTrigger(this.page, element, TimeWindowCondition.timeWindowCondition(element), callback);
    }
}